'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

require('flickity-as-nav-for');

require('flickity-imagesloaded');

var _flickity = require('flickity');

var _flickity2 = _interopRequireDefault(_flickity);

var _functional = require('../utils/functional');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var selectors = {
  carousel: '[data-carousel="carousel"]',
  carouselNav: '[data-carousel="carousel-nav"]'
};

var AboutPageCarousel = function () {
  function AboutPageCarousel(el) {
    (0, _classCallCheck3.default)(this, AboutPageCarousel);

    this.el = el;
    this.carouselNavEl = (0, _functional.getElement)(selectors.carouselNav);

    if (this.carouselNavEl) {
      this.carouselEl = (0, _functional.getElement)(selectors.carousel, { content: this.el });

      var initialIndex = (0, _functional.getElements)('.abt-Hero_Item').findIndex(function (el) {
        return el.dataset.initialIndex === 'true';
      });
      var _AboutPageCarousel = new _flickity2.default(this.carouselEl, {
        wrapAround: true,
        pageDots: false,
        cellAlign: 'center',
        adaptiveHeight: true,
        prevNextButtons: false,
        imagesLoaded: true,
        touchVerticalScroll: false,
        dragThreshold: 30,
        initialIndex: initialIndex,
        autoPlay: this.autoplaySpeed
      });

      _AboutPageCarousel.on('dragStart.el', function (event, pointer) {
        document.ontouchmove = function (e) {
          e.preventDefault();
        };
      });

      _AboutPageCarousel.on('dragEnd.flickity', function (event, pointer) {
        document.ontouchmove = function (e) {
          return true;
        };
      });

      var AboutPageThumbnailCarousel = new _flickity2.default(this.carouselNavEl, {
        asNavFor: this.carouselEl,
        contain: true,
        pageDots: false,
        cellAlign: 'center',
        adaptiveHeight: true,
        prevNextButtons: false,
        imagesLoaded: true,
        touchVerticalScroll: false,
        dragThreshold: 30,
        initialIndex: initialIndex
      });

      AboutPageThumbnailCarousel.on('dragStart.el', function (event, pointer) {
        document.ontouchmove = function (e) {
          e.preventDefault();
        };
      });

      AboutPageThumbnailCarousel.on('dragEnd.flickity', function (event, pointer) {
        document.ontouchmove = function (e) {
          return true;
        };
      });

      /**
       * @note asNavFor doesn't seem to work, so we'll add listeners ourselves
       */
      _AboutPageCarousel.on('change', function (index) {
        AboutPageThumbnailCarousel.select(index);
      });

      if (AboutPageThumbnailCarousel.cells) {
        AboutPageThumbnailCarousel.cells.forEach(function (cell, index) {
          cell.element.addEventListener('click', function () {
            _AboutPageCarousel.select(index);
            AboutPageThumbnailCarousel.select(index);
          });
        });
      }

      window.BAO = window.BAO || {};
      window.BAO.AboutPageCarousel = _AboutPageCarousel;
      window.BAO.AboutPageThumbnailCarousel = AboutPageThumbnailCarousel;
    }
  }

  (0, _createClass3.default)(AboutPageCarousel, [{
    key: 'autoplaySpeed',
    get: function get() {
      if (!('autoplaySpeed' in this.carouselEl.dataset)) {
        return false;
      }

      return Number(this.carouselEl.dataset.autoplaySpeed);
    }
  }]);
  return AboutPageCarousel;
}();

exports.default = AboutPageCarousel;